$(document).ready(function(){
    console.log('Ready');

    $('.product-form').find('input[name="id"]').change(function(){
        var value = $(this).attr('value');
        $('.pp_variant-real-product').addClass('hided');
        $('.pp_variant-real-product[data-id="'+value+'"]').removeClass('hided');
    
        $('.product__heading-inner').addClass('hided');
        $('.product__heading-inner[data-id="'+value+'"]').removeClass('hided');

        $('.product__description-inner').addClass('hided');
        $('.product__description-inner[data-id="'+value+'"]').removeClass('hided');

        $('.product_dynamic-icons').addClass('hided');
        $('.product_dynamic-icons[data-id="'+value+'"]').removeClass('hided');

        var newImage = $('.main_product-gallery-variant__js[data-id="'+value+'"]').attr('src');
        $('.main_product-gallery--image').attr('src', newImage);

        mainSwiper.slideTo(0);
        thumbsSwiper.slideTo(0);
        
    });

    $('.pp_description-readmore').click(function(){
        var data = $(this).attr('data-read');
        if (data == '1'){
            $(this).attr('data-read', '0');
            $(this).html('Rodyti mažiau');
            $('.shortDescriptionText').addClass('hided');
            $('.fullDescriptionText').removeClass('hided');
        }
        else{
            $(this).attr('data-read', '1');
            $(this).html('Skaityti daugiau');
            $('.shortDescriptionText').removeClass('hided');
            $('.fullDescriptionText').addClass('hided');
        }
    });

    $('.pp_indres-buy-btn').click(function(){
        var items = [];
        var currentId = $('.pp_variant-real-product:not(.hided)').attr("data-real-id");
        var currentQty = 1;

        items.push({ id: currentId, quantity: currentQty });

        jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            items: items,
        },
        dataType: "json",
        success: function () {
            console.log('Success, added');
        },
        error: function () {},
        });
    });


    $('.comparison_table-tooltip').click(function(){
        var currentId = $(this).attr('data-id');
        $('.comparison_tooltip-outer').removeClass('visible');
        $('.comparison_tooltip-outer[data-id="'+currentId+'"]').addClass('visible');
    });


    $('.comparison_tooltip-outer').on('click', function (e) {

        if ($(e.target).closest('.comparison_tooltip-close').length) {
            $(this).removeClass('visible');
            return;
        }

        if ($(e.target).closest('.comparison_tooltip-info').length) {
            return; 
        }

        $(this).removeClass('visible');
    });

        var thumbsSwiper = new Swiper(".main_product-swiper-thumbs", {
        spaceBetween: 10,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        });

        // Main Swiper
        var mainSwiper = new Swiper(".main_product-swiper", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".main_product-swiper-next",
            prevEl: ".main_product-swiper-prev",
        },
        thumbs: {
            swiper: thumbsSwiper,
        },
        });

});